/**
 *
 * RouteMarker
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import { Marker } from 'react-leaflet';
import { compose } from 'redux';
import withSettings from 'containers/SettingsProvider/withSettings';
import withRoute from 'containers/withRoute';
// import MenuInfoWindow from 'components/InfoWindow/MenuInfoWindow';
import { PATH_ROUTE } from 'containers/App/constants';
import { getDistanceString } from 'components/Distance';
import routeIconImage from 'images/icons/red_r.png';
import leafletIcon from 'utils/leafletIcon';
import { DIMMED_MARKER_OPACITY } from '../Map/constants';

class RouteMarker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.icon = leafletIcon({ iconUrl: routeIconImage });
  }

  render() {
    const { route, goTo, dimmed, units } = this.props;
    const title = `${route.title}, ${getDistanceString(route.distance, units)}`;
    const action = () => goTo(PATH_ROUTE, { routeId: route.id });
    return (
      <Marker
        title={title}
        position={route}
        icon={this.icon}
        onClick={action}
        opacity={dimmed ? DIMMED_MARKER_OPACITY : 1}
      />
    );
  }
}

RouteMarker.propTypes = {
  route: PropTypes.object.isRequired,
  goTo: PropTypes.func.isRequired,
  units: PropTypes.string.isRequired,
  dimmed: PropTypes.bool,
};

export default compose(
  withSettings(['units']),
  withRoute,
)(RouteMarker);
